import { createV3Queries } from "@query/utils/createV3Queries";
import { paymentCardsApi } from "@api";

export const queriesPaymentCards = createV3Queries(
  "paymentCardsApi",
  paymentCardsApi
);
